import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { UsersApiClient } from 'src/@shared/shared/api-clients';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class UsersDomainService {
  constructor(
    private commonService: CommonService,
    private usersApiClient: UsersApiClient
  ) {}

  getUsers(requestBody: any) {
    return this.usersApiClient.getUsers(requestBody);
  }

  getAllRoles() {
    return this.usersApiClient.getRoles();
  }

  getUserSites() {
    return this.usersApiClient.getUserSites();
  }

  getUserRecord(userId: any) {
    return this.commonService.API_GET(EndPoints.GetRecordById + `/${userId}`, false);
  }

  deleteUser(userId: any) {
    return this.commonService.API_DELETE(EndPoints.DeleteUser + `/${userId}`);
  }
  reInviteUser(userId: string) {
    // API binds [FromBody] string — body must be a JSON string literal (quoted), not a raw GUID.
    const requestBody = JSON.stringify(userId);
    return this.commonService.API_POST(EndPoints.ReInviteUser, requestBody, false);
  }

  updateUserProfile(userBody: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.UpdateUserProfile, userBody, false, {
      headers: hd,
    });
  }

  manageProfilePicture(formData: FormData) {
    return this.commonService.API_POSTFileUpload(EndPoints.UploadProfilePicture, formData);
  }
}
